import { ServiceApplication_Key } from "../../../config/helpers";
import { IContactFormDTO } from "../../../models/interfaces/IContactForm";
import { IReturn_Parent } from "../../../models/interfaces/IReturn_Parent";


import { apiSlice } from "../api";

interface queryBody {
  Application_Key: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Values: any;
}

export const gestionApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    mailNousContacter: builder.mutation<IContactFormDTO, IReturn_Parent>({
      query: (data) => {
        const body: queryBody = {
          Application_Key: ServiceApplication_Key,
          Values: data,
        };
        return {
          url: "/Gestion/Gestion_Contact",
          method: "POST",
          body: body,
        };
      },
    }),
  }),
});

export const { 
  useMailNousContacterMutation,
} = gestionApi;